import firebase from "firebase/app";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyD4dd6YAJjS_RVewVVPP4BlIdNIgbs2Wt4",
  authDomain: "unibathcareerscourse-1a8f2.firebaseapp.com",
  databaseURL: "https://unibathcareerscourse-1a8f2.firebaseio.com",
  projectId: "unibathcareerscourse-1a8f2",
  storageBucket: "unibathcareerscourse-1a8f2.appspot.com",
  messagingSenderId: "1047759649697",
  appId: "1:1047759649697:web:107295b56a7676415f69e0",
  measurementId: "G-C26BQLLMS1",
};

firebase.initializeApp(config);

const db = firebase.firestore();

const module1_visits = db.collection("Module1");
const module2_visits = db.collection("Module2");
const module3_visits = db.collection("Module3");
const module4_visits = db.collection("Module4");
const module5_visits = db.collection("Module5");
const module6_visits = db.collection("Module6");

export {
  module1_visits,
  module2_visits,
  module3_visits,
  module4_visits,
  module5_visits,
  module6_visits,
};
